(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["static-section-mobile-bar"]) return;
  try {
    
   window.addEventListener('scroll', function(){
      if(document.getElementById('mobileNavigation').classList.contains('adminEditor')) return;

      if((window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1) && window.matchMedia('(max-width: 1000px)').matches)
         document.getElementById('mobileNavigation').classList.add('disabled');
      else
         document.getElementById('mobileNavigation').classList.remove('disabled');
   });

  } catch(e) { console.error(e); }
})();
})();
